import React, { ReactElement } from 'react'
import Divider from '../Divider'
import AuctionOverview from './AuctionOverview'

const AuctionPanel = (): ReactElement => {
    return (
        <div className="panel">
            <Divider />
            <AuctionOverview />
        </div>
    )
}

export default AuctionPanel
